import { Reveal, SectionHeader } from "@/components/Reveal";

const chapters = [
  {
    num: "01",
    title: "Pharmaceutical",
    accent: "#e65c00",
    tags: ["Technology", "SaaS", "Manufacturing", "Distribution"],
    copy: "The infrastructure of medicine is being rebuilt. We back compliance-grade software, precision manufacturing, and the distribution networks that move critical therapies from bench to bedside — businesses defended by regulation, trust, and switching costs.",
    mono: true,
    img: "https://static.prod-images.emergentagent.com/jobs/7ad6febd-76b7-4ae8-88ea-7738fdc731d1/images/196052b69934eb6a275a12bf5b600d666d5152dca55db3706b7dd05aca5ff5f5.jpeg",
  },
  {
    num: "02",
    title: "Healthcare",
    accent: "#0a4d3c",
    tags: ["Clinical Care", "Wearable Health", "Health Technology"],
    copy: "We invest behind the shift toward specialized, ambulatory, and continuously measured care — clinics and care-delivery platforms with durable patient economics, wearable products that turn health into an always-on signal, and the technology that binds patient, provider, and outcome.",
    img: "https://images.unsplash.com/photo-1551190822-a9333d879b1f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    num: "03",
    title: "Outdoor",
    accent: "#0a4d3c",
    tags: ["Manufacturing", "E-Commerce", "SaaS Technology"],
    copy: "Participation in the outdoors is a generational tailwind, not a trend. We partner with the makers, marketplaces, and software platforms serving it — category-defining products, loyal communities, and the operating systems behind them.",
    img: "https://images.unsplash.com/photo-1597250861267-429663f244a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

const Thesis = () => (
  <section id="thesis" className="py-24 md:py-36 bg-[#070707] border-y border-white/[0.06]" data-testid="thesis-section">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
      <SectionHeader number="02" title="Where We Invest" testId="thesis" />
      <Reveal>
        <p className="font-display font-light text-2xl md:text-4xl tracking-tight max-w-3xl mb-20 leading-snug" data-testid="thesis-statement">
          We focus where innovation meets
          <span className="text-[#e65c00]"> absolute necessity.</span>
        </p>
      </Reveal>

      <div className="flex flex-col">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={0.05 * i}>
            <div
              className={`group grid lg:grid-cols-12 gap-8 lg:gap-16 py-16 border-t border-white/[0.08] ${i === chapters.length - 1 ? "border-b" : ""}`}
              data-testid={`thesis-chapter-${c.title.toLowerCase()}`}
            >
              <div className="lg:col-span-1">
                <span className="font-mono-tech text-sm text-[#8a8a8a]">{c.num}</span>
              </div>
              <div className="lg:col-span-6 flex flex-col justify-between gap-8">
                <div>
                  <h3 className="font-display font-light text-3xl md:text-5xl tracking-tight mb-6" style={{ color: "#f2f0eb" }}>
                    {c.title}
                  </h3>
                  <p className="text-[#a8a8a8] leading-relaxed max-w-xl">{c.copy}</p>
                </div>
                <div className="flex flex-wrap gap-3">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="font-mono-tech text-[10px] tracking-[0.2em] uppercase px-4 py-2 border border-white/[0.12] text-[#c9c7c2]"
                      style={{ borderLeft: `2px solid ${c.accent}` }}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="lg:col-span-5 overflow-hidden">
                <img src={c.img} alt={c.title} className={`thesis-img ${c.mono ? "thesis-img-mono" : ""} w-full h-64 md:h-80 object-cover`} loading="lazy" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Thesis;
